<script>
import { mapState } from 'pinia';

import { useUserStore } from '../../../../store/useUserStore.js';

export default {
  name: 'CpOriginalPost',
  components: {
    CpSearchResult: require('../../explore-campaigns/result').default,
    CpSocialFeedNewsPost: require('../../social-feed/posts/news-post').default,
    CpSocialFeedVideoPost: require('../../social-feed/posts/video-post').default,
    CpSocialFeedLivestreamPost: require('../../social-feed/posts/livestream-post').default,
    CpSocialFeedPetitionPost: require('../../social-feed/posts/petition-post').default,
    CpSocialFeedRacePost: require('../../social-feed/posts/race-post').default,
    CpSocialFeedCandidatePost: require('../../social-feed/posts/candidate-post').default,
    CpSocialFeedBlogPost: require('../../social-feed/posts/blog-post').default,
    CpOpinionsContainer: require('../../opinions/opinions-container').default,
    CpOpinionsItem: require('../../opinions/opinions-item').default,
    CpSharePostItem: require('../../social-feed/posts/share-post-item').default,
    CpSocialFeedNewMemberPost: require('../../social-feed/posts/new-member-post').default,
    CpSocialFeedLobbyPost: require('../../social-feed/posts/lobby-post').default,
    CpSocialFeedCustomContent: require('../../social-feed/posts/CustomContent').default,
    CpSocialFeedPollPost: require('../../social-feed/posts/poll-post').default,
    CpEventCard: require('../../events/event-card.vue').default,
    CpGroup: require('../../groups/group-card').default,
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginBottom: require('../../directives/margins').marginBottom,
    marginTop: require('../../directives/margins').marginTop,
    marginLeft: require('../../directives/margins').marginLeft,
    marginRight: require('../../directives/margins').marginRight,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { currentUser: this.userProfileData };
  },
  computed: {
    ...mapState(useUserStore, ['userProfileData']),
  },
};
</script>

<template>
  <div>
    <div v-if="post.post_type == 'campaign'" style="margin-bottom: 2.5em">
      <CpSearchResult
        :result="post.data_post"
        :explore="true"
        :feed="true"
        :current-user="currentUser"
        :modal="false"
        :results-url-suffix="false"
      />
    </div>
    <div v-if="post.post_type == 'custom_content'">
      <CpSocialFeedCustomContent :post="post.data_post" :explore="true" />
    </div>
    <div v-if="post.post_type == 'opinion'">
      <CpOpinionsItem :data="post.data_post" :explore="true" :type="'opinion'" />
    </div>
    <div v-if="post.post_type == 'blog'">
      <CpSocialFeedBlogPost :blog="post.data_post" :explore="true" />
    </div>
    <div v-if="post.post_type == 'candidate'">
      <CpSocialFeedCandidatePost :candidate="post.data_post" :for-share="false" :explore="true" :modal="false" :iconState="true" />
    </div>
    <div v-if="post.post_type == 'news'">
      <CpSocialFeedNewsPost :news="post.data_post" :explore="true" />
    </div>
    <div v-if="post.post_type == 'post_shared'">
      <CpSharePostItem :post-shared="post.data_post" :results-url-suffix="false" />
    </div>
    <div v-if="post.post_type == 'petition'">
      <CpSocialFeedPetitionPost :petition="post.data_post" :explore="true" :user="currentUser" />
    </div>
    <div v-if="post.post_type == 'election'">
      <CpSocialFeedRacePost :race="post.data_post" :explore="true" />
    </div>
    <div v-if="post.post_type == 'new_member'">
      <CpSocialFeedNewMemberPost :newMember="post.data_post" :user="currentUser" />
    </div>
    <div v-if="post.post_type == 'lobby'">
      <CpSocialFeedLobbyPost :lobby="post?.data_post ?? post" :for-share="false" :explore="true" :iconState="true" :user="currentUser" />
    </div>
    <div v-if="post.post_type == 'poll'">
      <CpSocialFeedPollPost :poll="post.data_post" :for-share="false" :explore="true" :user="currentUser" />
    </div>
    <div v-if="post.post_type == 'event'">
      <CpSocialFeedLivestreamPost
        v-if="post.data_post.archive_url && post.data_post.status == 'shared'"
        :playback="post.data_post.archive_url"
        :title="post.data_post.title"
        :type="'event'"
        :data="post.data_post"
      />
      <CpEventCard v-else :event="post.data_post" />
    </div>
    <div v-if="post.post_type == 'group'" v-margin-bottom="2">
      <CpGroup :group="post.data_post" :current-user="currentUser" :type="post.data_post.type" />
    </div>
    <div v-if="post.post_type == 'group_opinion'">
      <CpOpinionsItem :data="post.data_post" :explore="true" :type="'group-opinions'" />
    </div>
    <div v-if="post.post_type == 'livestream'">
      <CpSocialfeedLivestreamPost :playback="post.data_post.archive_url" :title="post.data_post.title" :type="post.data_post.type" :data="post.data_post" />
    </div>
  </div>
</template>

<style>
div.social-feed-post-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 7px 0px;
}
</style>
